import { BannerId } from '../../../typings/banners';
import { BannerImageType } from '../../../typings/domain';
import { InternalResourceId } from '../../../typings/internalBanners';

export const UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY = 'UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY';
export type UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY = typeof UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY;

export interface UpdateInternalBannerImageByGallery {
    type: UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    imagesHash: string[];
    bannerType: BannerImageType;
}

export function updateInternalBannerImageByGalleryAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    imagesHash: string[],
    bannerType: BannerImageType
): UpdateInternalBannerImageByGallery {
    return {
        type: UPDATE_INTERNAL_BANNER_IMAGE_BY_GALLERY,
        bannerId,
        resourceId,
        imagesHash,
        bannerType
    };
}
